module.exports = __webpack_public_path__ + "static/media/GeneralSleepCheckup.a4ee8cf4.png";